/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_EmptyInputs */



/**
* | output |
* | --- |
* | "No chats yet for this project." |
*
* @param {Assistant_History_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_empty = /** @type {((inputs?: Assistant_History_EmptyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_EmptyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune discussion n'a encore eu lieu pour ce projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für dieses Projekt gibt es noch keine Chats.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna chat ancora disponibile per questo progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока нет обсуждений по этому проекту.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todavía no hay chats para este proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该项目目前还没有讨论。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロジェクトに関するチャットはまだありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस प्रोजेक्ट के लिए अभी तक कोई बातचीत नहीं हुई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda não há chats para este projeto.")
	return /** @type {LocalizedString} */ ("No chats yet for this project.")
});